import { Component, inject, signal } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { TotpAuthStore } from './totp-auth.store';
import { TOTP_DIGIT_COUNT, TotpCodeComponent } from './totp-code.component';

@Component({
  imports: [MatDialogModule, MatProgressSpinner, TotpCodeComponent],
  selector: 'avs-totp-remove-app-dialog',
  templateUrl: './totp-remove-app-dialog.component.html',
})
export class TotpRemoveAppDialogComponent {
  protected isCodeComplete = signal(false);
  protected store = inject(TotpAuthStore);
  protected token = signal('');

  constructor() {
    this.store.reset();
  }

  protected onTokenChange(value: string) {
    this.token.set(value);
    this.isCodeComplete.set(value.length === TOTP_DIGIT_COUNT);

    if (this.store.error()) {
      this.store.clearError();
    }
  }

  protected removeApp() {
    if (this.isCodeComplete()) {
      this.store.removeApp(this.token());
    }
  }
}
